import SettingsCard from '../settings_card'
import AssignedCategories from './categories/assigned_categories'

const CategoriesCard = ({ asset, cycleID, langID }) => {
  const assetType = asset?.asset_type
  const isAd = assetType === 'ad'
  const availableCategories = asset.available_categories ?? []
  const selectableSections = availableCategories.filter((section) => (section.child_categories ?? []).length > 0)
  const showCatalogCategories = !['ad', 'episode', 'track'].includes(assetType) && selectableSections.length > 0
  const showWarningSlateAssignment = isAd && asset?.is_warning_slate
  const showFeatured = assetType === 'featured-content'

  if (!showCatalogCategories && !showWarningSlateAssignment && !showFeatured) return null

  return (
    <SettingsCard title='Categories' description='Choose which categories this asset belongs to in each section.'>
      <AssignedCategories
        availableCategories={selectableSections}
        availableWarningSlates={asset.available_warning_slates ?? []}
        categories={asset.categories ?? []}
        assetID={asset.id}
        assetType={assetType}
        cycleID={cycleID}
        langID={langID}
        issue={asset.asset_issues?.find((issue) => issue.validator_group === 'category')}
        isWarningSlate={asset?.is_warning_slate}
      />
    </SettingsCard>
  )
}

export default CategoriesCard
